import { PureComponent } from "react";

import Spinner from "~/components/shared/Spinner";

export default class SectionLoader extends PureComponent {
  render() {
    return (
      <div className="my-4 text-center">
        <Spinner />
      </div>
    );
  }
}
